const Utils = require('../utils');

const makeEvents = () => {
	let infoById = {}; // { [divId]: { slot, ad, isEmpty }, ... }
	const cbs = {}; // { slotRenderEnded: [cb1, cb2], ... }
	const trigger = (id, type, data) => {
		const info = infoById[id];
		if (info) {
			Object.assign(info, data);
			cbs[type]?.forEach((cb) => Utils.withCatch(() => cb(info)));
		}
	};
	return {
		trigger,
		add(type, listener) {
			cbs[type] = cbs[type] || [];
			cbs[type].push(listener);
		},
		remove(type, listener) {
			cbs[type] = cbs[type]?.filter((cb) => cb !== listener);
		},
		onSlotsDestroyed() {
			infoById = {};
		},
		slotRequested({ slot }) {
			const id = slot.getSlotElementId();
			infoById[id] = { slot };
			trigger(id, 'slotRequested');
		},
	};
};

module.exports = { makeEvents };
